import { gtag } from 'ga-gtag'

type Ga4EventListener = (eventName: string, eventParams: any) => void
const listeners: Ga4EventListener[] = []

export const onGa4Event = (listener: Ga4EventListener) => {
  listeners.push(listener)
}

const __ga4Event = (eventName: string, eventParams: any)  => {
  gtag('event', eventName, eventParams);
  listeners.forEach(l => l(eventName, eventParams));
}

export const ga4ScreenView = (screenName: string, appName: string = 'KuraemonCloudWeb') => {
  try {
    __ga4Event('screen_view', {
      app_name: appName,
      screen_name: screenName
    });
  } catch (e) {
    console.error(e);
  }
}

export const ga4Event = (eventName: string, eventParams: any)  => {
  try {
    __ga4Event(eventName, eventParams);
  } catch (e){
    console.error(e);
  }
}

export const ga4EventAsync = (eventName: string, eventParams: any): Promise<void> => {
  return new Promise((resolve) => {
    try {
      // ga-gtagでevent_callbackを使用してGoogleAnalyticsからの送信完了通知を受け取る
      __ga4Event(eventName, {
        ...eventParams,
        event_callback: () => {
          resolve();
        }
      });

      // タイムアウト処理（2秒後に強制的にresolve）
      setTimeout(resolve, 2000);
    } catch (e){
      console.error(e);
      resolve();
    }
  });
}

export function updateGa4UserId(accountId: string) {
  try {
    gtag('set', { user_id: accountId });
    gtag('set', {
      user_properties: {
        account_id: accountId
      }
    });
  } catch (e){
    console.error(e);
  }
}
